/* eslint-disable prettier/prettier */
import React, { Fragment } from 'react';
import { useHistory } from 'react-router-dom';

import moment from 'moment';

import Header from 'components/AppBar';
import Loader from 'components/Loader';
import { Mobile } from 'components/Responsive';
import useIsMobile from 'hooks/useIsMobile';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { CostCenter } from 'models/costCenter';
import { CostCenterReportRequest, CostCenterReportResponse } from 'models/costCenterReport';
import { RenderTravelReportViewCostCenter } from 'screens/components/CostCenterReport/RenderTravelReportView';
import { getFormattedPrice } from 'utils/currency';
import { statusTranslation } from 'utils/statusTag';

interface Props {
  costCenterList: CostCenter[];
  fetchReportSummary: (filters: CostCenterReportRequest, type: string) => Promise<any>;
  isLoading: boolean;
  isSubmit: boolean;
  report?: CostCenterReportResponse;
}

const CostCenterReport = ({ costCenterList, fetchReportSummary, isLoading, isSubmit, report }: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory();
  const isMobile = useIsMobile();
  const handlePeriodText = (text?: string) => { };

  const navigateToDashboard = () => history.push('/costCenter');

  const formattedPrice = (price?: number, currency?: string): string => {
    const { formatted } = getFormattedPrice({ value: price || 0, currency: currency, t });
    return formatted;
  };

  const formatDate = (date: string) => moment(date).format('DD/MM/YYYY');

  const formatStatus = (status: string) => statusTranslation(status, t);

  return (
    <Fragment>
      {isLoading ? (
        <Loader fullScreen />
      ) : (
        <Fragment>
          <Mobile>
            <Header goBack={navigateToDashboard}>{t('costCenter.report.title')}</Header>
          </Mobile>
          {RenderTravelReportViewCostCenter(
            true,
            costCenterList,
            isLoading,
            isSubmit,
            isMobile,
            t,
            fetchReportSummary,
            handlePeriodText,
            formattedPrice,
            formatDate,
            formatStatus,
            report,
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

export default CostCenterReport;
